(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview/assets/javascripts/overview.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview/assets/javascripts/overview.js');
"use strict";


const {
  useContext,
  useEffect,
  useState,
  useRef
} = React;
const {
  useRouteMatch,
  useLocation,
  useHistory
} = ReactRouterDOM;
const {
  useSelector
} = ReactRedux;
const {
  lazy
} = svs.components.lbUtils.lazy;
const {
  WidgetArea
} = svs.components.lbUtils.widgetArea;
const {
  usePlayerCompetitions
} = svs.components.marketplaceCompetition.services.hooks;
const {
  Teams
} = svs.components.marketplaceCompetition.teams;
const {
  InvitationHero
} = svs.components.marketplaceCompetition.overview;
const {
  decodeInitiationLink
} = svs.components.marketplaceShared.invitation;
const {
  useCompetitionId
} = svs.components.marketplaceCompetition.competitionContext;
const {
  CompetitionMenuContext
} = svs.components.marketplaceCompetition.competitionMenu;
const {
  selectCompetition
} = svs.components.marketplaceCompetition.services.selectors.competitionSelectors;
const {
  useTeams
} = svs.components.marketplaceCompetition.services.hooks;
const {
  useIsBeforeSignupStartTime,
  useIsBeforeSignupEndTime
} = svs.components.marketplaceCompetition.team.useCompetitionSignupTime;
const TabsLoader = () => React.createElement("div", null, "Laddar..");
const CreateTeam = lazy('/cl/marketplace-competition/react:create-team', () => svs.components.marketplaceCompetition.createTeam.CreateTeam, {
  fallback: TabsLoader
});
const OverView = () => {
  const competitionId = useCompetitionId();
  const competition = useSelector(state => selectCompetition(state, competitionId));
  const competitionHasStarted = (competition === null || competition === void 0 ? void 0 : competition.details) && new Date() > new Date(competition.details.startTime);
  const location = useLocation();
  const {
    teams: teamsData
  } = useTeams(competitionId);
  const fromJoin = useRef(location.search.includes('fromJoin=true'));
  const playerCompetitions = usePlayerCompetitions({
    forceFetch: fromJoin.current
  });
  const isPlayerRegisteredInCompetition = competitionId && (playerCompetitions === null || playerCompetitions === void 0 ? void 0 : playerCompetitions[competitionId]);
  const {
    params
  } = useRouteMatch();
  const [isCreateTeam, setIsCreateTeam] = useState(Boolean(location.pathname.includes('/skapa-lag')));
  const {
    competitionMenu
  } = useContext(CompetitionMenuContext);
  const isBeforeSignupStartTime = useIsBeforeSignupStartTime({
    competition
  });
  const isBeforeSignupEndTime = useIsBeforeSignupEndTime({
    competition
  });
  const isWithinSignupTime = !isBeforeSignupStartTime && isBeforeSignupEndTime;
  const history = useHistory();
  useEffect(() => {
    if (isCreateTeam && !isWithinSignupTime) {
      const pathname = location.pathname.replace('/skapa-lag', '');
      history.replace(pathname);
    }
  });
  useEffect(() => {
    if (fromJoin.current) {
      fromJoin.current = false;
    }
  }, []);
  useEffect(() => {
    setIsCreateTeam(Boolean(location.pathname.includes('/skapa-lag')));
    return () => {
      setIsCreateTeam(false);
    };
  }, [location]);
  const isListingTeams = competitionHasStarted || (teamsData === null || teamsData === void 0 ? void 0 : teamsData.length) > 0 || isPlayerRegisteredInCompetition || fromJoin.current;
  return React.createElement(React.Fragment, null, params.encodedLink ? React.createElement(InvitationHero, {
    invitation: decodeInitiationLink(params.encodedLink)
  }) : React.createElement(svs.components.marketplaceCompetition.overviewHero.OverviewHero, null), React.createElement("span", {
    className: "competition-overflow-up"
  }, competitionMenu), React.createElement("div", {
    className: "competition-center-to-screen"
  }, React.createElement("div", {
    className: "competition-content competition-overview"
  }, Boolean(!isCreateTeam && isListingTeams) && React.createElement(Teams, null), Boolean(!params.encodedLink && isCreateTeam) && React.createElement(CreateTeam, null), React.createElement("div", {
    className: "competition-news",
    "data-testid": "qa-competition-news"
  }, React.createElement(WidgetArea, {
    className: "competition-news-widget",
    widgetArea: "tipssmNewsWidgetArea"
  })))));
};
setGlobal('svs.components.marketplaceCompetition.overview.OverView', OverView);

 })(window);